"use client";

import { PandaLogo } from "@/components/panda-logo";

// Public status page (e.g. incident.io). Only rendered when configured so we
// never ship a link to a page that does not exist yet. See
// docs/incident-io-setup.md.
const STATUS_PAGE_URL = process.env.NEXT_PUBLIC_STATUS_PAGE_URL;

export function AppFooter() {
  return (
    <footer className="border-t border-border bg-[#F8FAFC] pb-20 sm:bg-background sm:border-border sm:py-6 sm:pb-6 dark:bg-card sm:dark:bg-background">
      {/* Mobile layout — vertical stack so legal links don't squash
          under the support widget. Desktop keeps the original
          single-row layout via the sm: overrides. */}
      <div className="flex flex-col gap-6 p-4 sm:mx-auto sm:max-w-6xl sm:flex-row sm:items-center sm:justify-between sm:gap-4 sm:p-0 sm:px-4 sm:py-0 sm:sm:px-6">
        <div className="flex items-center gap-2">
          <PandaLogo size="sm" className="rounded-md" />
          <span className="font-[family-name:var(--font-rubik),sans-serif] text-2xl font-bold leading-none tracking-tight text-foreground sm:font-[inherit] sm:text-sm sm:font-bold sm:leading-normal sm:tracking-normal">
            panda
          </span>
        </div>
        <div className="flex flex-wrap items-center gap-4 font-[family-name:var(--font-rubik),sans-serif] text-xs font-normal leading-4 text-[#77869D] sm:gap-4 sm:font-[inherit] sm:text-xs sm:leading-normal sm:text-muted-foreground">
          {STATUS_PAGE_URL && (
            <a
              href={STATUS_PAGE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors hover:text-foreground"
            >
              Status
            </a>
          )}
          <a href="/terms" className="transition-colors hover:text-foreground">
            Terms &amp; Conditions
          </a>
          <a href="/privacy" className="transition-colors hover:text-foreground">
            Privacy Policy
          </a>
          {/* Refund Policy and a reachable contact address are both required by
              Paddle's domain review — see app/(auth)/refund/page.tsx. */}
          <a href="/refund" className="transition-colors hover:text-foreground">
            Refund Policy
          </a>
          <a
            href="mailto:help@panda.new"
            className="transition-colors hover:text-foreground"
          >
            Contact
          </a>
          <span>&copy; {new Date().getFullYear()} Panda</span>
        </div>
      </div>
    </footer>
  );
}
